<!-- Tabla de grupo (compartida para todos los modos de agrupación) -->
<ng-template #tablaGrupo let-eventos="eventos">
  <mat-table [dataSource]="eventos" class="mat-elevation-z8">
    <!-- Tipo: Servicio técnico / Verificación + categoría (antes sólo un color
         en el borde de la fila) -->
    <ng-container matColumnDef="tipo">
      <mat-header-cell *matHeaderCellDef>Tipo</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="st-celda-col">
          @if (element.filtrador === 'Verificación') {
            <span class="irx-estado irx-estado--info">Verificación</span>
          } @else {
            <span class="irx-estado irx-estado--neutro">
              <mat-icon>build</mat-icon>
              Servicio técnico
            </span>
          }
          @if (categoriaTecnica(element.tipoEvento); as categoria) {
            <span class="st-secundario">{{ categoria }}</span>
          }
        </div>
      </mat-cell>
    </ng-container>

    <!-- Estado -->
    <ng-container matColumnDef="estado">
      <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (estadoServicioTecnico(element.estado); as e) {
          <span class="irx-estado" [ngClass]="'irx-estado--' + e.tono">
            @if (e.icono) {
              <mat-icon>{{ e.icono }}</mat-icon>
            }
            {{ e.texto }}
          </span>
        } @else {
          <span class="no-info">Sin estado</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Título -->
    <ng-container matColumnDef="titulo">
      <mat-header-cell *matHeaderCellDef>Título</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.valores?.titulo) {
          {{ element.valores.titulo }}
        } @else {
          <span class="no-info">Sin título</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Entidad -->
    <ng-container matColumnDef="entidad">
      <mat-header-cell *matHeaderCellDef>Entidad</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.alarma?.nombre) {
          <span class="st-linea">
            <mat-icon>doorbell</mat-icon>
            <span>{{ element.alarma.nombre }}</span>
          </span>
        } @else if (element.luminaria?.identificacion) {
          <span class="st-linea">
            <mat-icon>lightbulb</mat-icon>
            <span>{{ element.luminaria.identificacion }}</span>
          </span>
        } @else if (
          element.tracker?.nombre || element.tracker?.identificacion
        ) {
          <span class="st-linea">
            <mat-icon>gps_fixed</mat-icon>
            <span>
              {{ element.tracker.nombre || element.tracker.identificacion }}
            </span>
          </span>
        } @else if (element.sirena?._id) {
          <span class="st-linea">
            <mat-icon>campaign</mat-icon>
            <span>{{ element.sirena._id }}</span>
          </span>
        } @else if (element.activo?.identificacion) {
          <span class="st-linea">
            <mat-icon>directions_car</mat-icon>
            <span>{{ element.activo.identificacion }}</span>
          </span>
        } @else {
          <span class="no-info">Sin asignar</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Técnico -->
    <ng-container matColumnDef="tecnico">
      <mat-header-cell *matHeaderCellDef>Técnico</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span class="st-linea">
          <img
            class="st-foto"
            [src]="
              element.detallesTecnicos?.tecnico?.datosPersonales?.foto ||
              'assets/images/anon.png'
            "
            alt="Foto"
          />
          <span [class.no-info]="!element.detallesTecnicos?.tecnico">
            {{ obtenerNombreTecnico(element) }}
          </span>
        </span>
      </mat-cell>
    </ng-container>

    <!-- Cliente -->
    <ng-container matColumnDef="cliente">
      <mat-header-cell *matHeaderCellDef>Cliente</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.cliente?.nombre) {
          {{ element.cliente.nombre }}
        } @else {
          <span class="no-info">Sin cliente</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Fecha (de actividad: con "hace x") -->
    <ng-container matColumnDef="fecha">
      <mat-header-cell *matHeaderCellDef>Fecha</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (fechaCelda(element.fechaCreacion); as fecha) {
          <span class="st-fecha">
            <span>{{ fecha }}</span>
            <span class="st-secundario">
              {{ haceCelda(element.fechaCreacion) }}
            </span>
          </span>
        } @else {
          <span class="no-info">Sin fecha</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Acciones (sueltas, como hasta ahora; Eliminar al final) -->
    <ng-container matColumnDef="acciones">
      <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="st-acciones">
          <button
            irxBotonIcono
            tamano="compacto"
            tooltip="Editar"
            (click)="editar(row)"
            [disabled]="
              !helper.tienePermiso('Servicio Técnico - Editar solicitudes')
            "
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            irxBotonIcono
            tamano="compacto"
            tooltip="Asignar técnico"
            (click)="asignar(row)"
            [disabled]="
              !helper.tienePermiso('Servicio Técnico - Reasignar solicitudes')
            "
          >
            <mat-icon>person_add</mat-icon>
          </button>
          <button
            irxBotonIcono
            tamano="compacto"
            tooltip="Atender"
            (click)="atender(row)"
            [disabled]="
              !helper.tienePermiso('Servicio Técnico - Atender solicitudes')
            "
          >
            <mat-icon>troubleshoot</mat-icon>
          </button>
          <button
            irxBotonIcono
            tamano="compacto"
            tono="peligro"
            tooltip="Eliminar"
            (click)="eliminar(row)"
            [disabled]="
              !helper.tienePermiso('Servicio Técnico - Eliminar solicitudes')
            "
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnasGrupo"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnasGrupo"></mat-row>
  </mat-table>
</ng-template>

<!-- Tabs -->
<mat-tab-group
  [(selectedIndex)]="selectedTab"
  (selectedIndexChange)="tabChanged($event)"
>
  <!-- =================== PENDIENTES =================== -->
  <mat-tab>
    <ng-template mat-tab-label>
      <span>Pendientes</span>
      @if (totalCount) {
        <span class="tab-contador">
          {{ totalCount.toLocaleString('es-AR') }}
        </span>
      }
    </ng-template>
    <ng-template matTabContent>
      <!-- Modo Agrupación -->
      <div class="st-agrupacion">
        <irx-segmentado
          [(ngModel)]="modoAgrupacion"
          (change)="cambioModoAgrupacion($event)"
        >
          <irx-segmento value="1">Sin agrupar</irx-segmento>
          <irx-segmento value="2">Por categoría</irx-segmento>
          <irx-segmento value="3">Por dispositivo</irx-segmento>
          <irx-segmento value="4">Por módulo</irx-segmento>
          <irx-segmento value="5">Por cliente</irx-segmento>
        </irx-segmentado>
      </div>

      <!-- Loading -->
      @if (loading) {
        <app-loading text="Cargando"></app-loading>
      }

      <!-- Sin agrupar -->
      @if (modoAgrupacion === '1') {
        <ng-container
          *ngTemplateOutlet="tablaGrupo; context: { eventos: datos }"
        ></ng-container>
      }

      <!-- Por Categoría -->
      @if (modoAgrupacion === '2') {
        <mat-accordion displayMode="flat">
          @for (llave of categorias; track llave) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ llave }} ({{ eventosPorCategoria[llave].length }})
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-container
                *ngTemplateOutlet="
                  tablaGrupo;
                  context: {
                    eventos: eventosPorCategoria[llave],
                  }
                "
              ></ng-container>
            </mat-expansion-panel>
          }
        </mat-accordion>
      }

      <!-- Por Dispositivo -->
      @if (modoAgrupacion === '3') {
        <mat-accordion displayMode="flat">
          @for (llave of entidades; track llave) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ llave }} ({{ eventosPorEntidad[llave].length }})
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-container
                *ngTemplateOutlet="
                  tablaGrupo;
                  context: {
                    eventos: eventosPorEntidad[llave],
                  }
                "
              ></ng-container>
            </mat-expansion-panel>
          }
        </mat-accordion>
      }

      <!-- Por Módulo -->
      @if (modoAgrupacion === '4') {
        <mat-accordion displayMode="flat">
          @for (llave of modulos; track llave) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ llave }} ({{ eventosPorModulo[llave].length }})
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-container
                *ngTemplateOutlet="
                  tablaGrupo;
                  context: {
                    eventos: eventosPorModulo[llave],
                  }
                "
              ></ng-container>
            </mat-expansion-panel>
          }
        </mat-accordion>
      }

      <!-- Por Cliente -->
      @if (modoAgrupacion === '5') {
        <mat-accordion displayMode="flat">
          @for (llave of clientes; track llave) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ llave }} ({{ eventosPorCliente[llave].length }})
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-container
                *ngTemplateOutlet="
                  tablaGrupo;
                  context: {
                    eventos: eventosPorCliente[llave],
                  }
                "
              ></ng-container>
            </mat-expansion-panel>
          }
        </mat-accordion>
      }
    </ng-template>
  </mat-tab>

  <!-- =================== HISTORIAL =================== -->
  <mat-tab label="Historial">
    <ng-template matTabContent>
      <app-tabla
        [datos]="datosHistorico"
        [columnas]="columnasHistorico"
        [totalCount]="totalCountHistorico"
        [(query)]="queryHistorico"
        (queryChange)="listarHistorico()"
        [filtros]="filtrosHistorico"
        [firstLastButtons]="false"
        [goto]="false"
        [emptyState]="{
          title: 'Todavía no hay servicios técnicos finalizados',
          subtitle: 'Probá cambiando los filtros.',
        }"
      ></app-tabla>
    </ng-template>
  </mat-tab>
</mat-tab-group>
